function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.397.554L.47.47a.75.75 0 01.976-.073L1.53.47 6 4.939l4.47-4.47a.75.75 0 111.06 1.061L7.061 6l4.47 4.47a.75.75 0 01.072.976l-.073.084a.75.75 0 01-.976.073l-.084-.073L6 7.061l-4.47 4.47A.75.75 0 01.47 10.47L4.939 6 .469 1.53A.75.75 0 01.398.554L.47.47.397.554z",
  fill: "#E63535"
});

function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCrossIcon;